var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 136a72 72 0 1 1 144 0A72 72 0 1 1 88 136zm176 0A104 104 0 1 0 56 136a104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm176 0a104 104 0 1 0 -208 0 104 104 0 1 0 208 0zM208 320c53 0 96 43 96 96l0 16c0 8.8-7.2 16-16 16L48 448c-8.8 0-16-7.2-16-16l0-16c0-53 43-96 96-96l80 0zm-80-32C57.3 288 0 345.3 0 416l0 16c0 26.5 21.5 48 48 48l240 0c26.5 0 48-21.5 48-48l0-16c0-32.4-12-61.9-31.8-84.4C280.7 304.9 246.3 288 208 288l-80 0zM432 480l80 0c70.7 0 128-57.3 128-128l0-16c0-26.5-21.5-48-48-48l-240 0c-12.7 0-24.2 4.9-32.8 13c7.7 7.4 14.7 15.7 20.8 24.5c2.9-3.4 7.2-5.5 12.1-5.5l240 0c8.8 0 16 7.2 16 16l0 16c0 53-43 96-96 96l-80 0c-24.6 0-47-9.2-64-24.4l0 8.4c0 9.8-1.8 19.2-5 27.8c19.9 12.8 43.6 20.2 69 20.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/employee.1437cad69919ffceb545f17c432cd7e6.svg";
export { ForwardRef as ReactComponent };